//@ts-check
/** @param {Fox} fox */
module.exports = (fox) => {
	require('../../common/widget/BottomBanner.es')(fox);

	const $ = fox.jQuery;
	const getMaxDiscount = require('../../common/getMaxDiscount')(fox);

	fox.registerWidget('UserAccess_UpgradeBanner', {
		configure: function () {
			this.registerOptions('', {
				template: 'upgrade_promo_banner_strip',
				'templateOptions.maxDiscount': getMaxDiscount(),
				showBannerPredicat: () => fox.isEmpty(this.storage.getItem(this.memberId)) && fox.getEnv('site.state') !== 4 
				&& fox.getEnv('siteProps.ubs.joinOptions.options').length > 0
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.storage = new fox.LocalStorageObjectService({
				lsLabel: '_uaub_',
				cleanCheckInterval: 1000 * 60 * 2 * 24
			});
			
			this.memberId = this.rwom1('@root .PermissionManager').getMemberInfo('id');

			this.setTemplateOptions('data', this.storage.getItem(this.memberId));

			this.callParent('init', arguments);
		},

		rendering: function () {
			this.setTemplateOptions('data', this.storage.getItem(this.memberId));

			this.callParent('rendering', arguments);
		},

		closeBanner: function () {
			this.storage.setItem(this.memberId, {value: 1});

			this.callParent('closeBanner', arguments);
		},
	}, 'Common_BottomBanner');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/upgradeBanner.es.js